import { User } from "@/controller/user";
import { ref, onMounted } from "vue";
import Auth from "@/controller/auth";
import Chat, { Message } from "@/controller/chat";

const userProfile = Auth.getUserProfile() as User;
const chatController = new Chat(userProfile);

export default function useMessage() {
  const message = ref("");
  const messages = ref<Message[]>([]);

  onMounted(async () => {
    const callback = async (result: Message[]) => {
      messages.value = result;
    };

    chatController.watchChat(callback);
  });

  async function sendTextMessage() {
    await chatController.sendTextMessage(message.value);
    message.value = "";
  }

  async function sendImageMessage(images: string[]) {
    await chatController.sendImageMessage(images);
  }

  return {
    messages,
    message,
    sendTextMessage,
    sendImageMessage
  };
}
